import React from 'react'
import {List, Button} from 'antd';
import 'antd/es/list/style/css'
import 'antd/es/button/style/css'
import { DownloadOutlined } from '@ant-design/icons';
import { usePromise, Async } from 'react-promise'


const FileBox = (props) => {
    const [loading, setLoading] = React.useState(true);
    const [files, setFiles] = React.useState(props.files)
    files.sort((file1, file2) => {
        let file1Timestamp = file1.name.split('_')[0]
        let file2Timestamp = file2.name.split('_')[0]

        return file2Timestamp - file1Timestamp
    })
    const getFormattedName = (name) => {
        var z = name.split('_')
        z.shift()
        return z
    }
    const getDate = (name) => {
        var d = new Date(0)
        d.setUTCMilliseconds(name.split('_').shift())
        return `${d.toLocaleDateString('en-us')} - ${d.toLocaleTimeString('en-us')}`
    }
    const t = async () => {
        return "#"
    }
    

    React.useEffect(() => {
        files.length>0 ? setLoading(false) : setLoading(true)
    },[files])

    React.useEffect(() => {
        setFiles(props.files)
    }, [props.files])
    
    
    return (
        <List
            dataSource={files}
            loading={loading}
            renderItem={file => {
                return (<List.Item>
                    <List.Item.Meta
                        title={getFormattedName(file.name)}
                        description={"Created: " + getDate(file.name)}
                        avatar={<Button icon={<DownloadOutlined/>} target="_blank" href={file.url}></Button>}
                        
                        />
                </List.Item>)
            }}
            />
    )
};

export default FileBox;